import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Dropdown.css";
import * as React from "react";
import { ObservableArray, ObservableValue } from '../../Core/Observable';
import * as Utils_Accessibility from '../../Core/Util/Accessibility';
import { format } from '../../Core/Util/String';
import { FilteredListSelection } from '../../List';
import { getListBoxItemsValue, getUnselectableRanges, wrapListBoxItems } from '../../ListBox';
import { ItemsObserver, Observer } from '../../Observer';
import * as Resources from '../../Resources.Dropdown';
import { DropdownSelection } from '../../Utilities/DropdownSelection';
import { getItemsValue } from '../../Utilities/Provider';
import { DropdownCallout } from "./DropdownCallout";
import { DropdownExpandableTextField } from "./DropdownExpandableTextField";
var Dropdown = /** @class */ (function (_super) {
    tslib_1.__extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.expandable = React.createRef();
        _this.filterText = new ObservableValue("");
        _this.collapse = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.expand = function () {
            if (_this.expandable.current) {
                _this.expandable.current.expand();
            }
        };
        _this.onDismiss = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.onExpand = function () {
            if (_this.props.onExpand) {
                _this.props.onExpand();
            }
            _this.updateFilteredItems();
        };
        _this.onActivate = function (event, item) {
            if (!event.defaultPrevented && event.type === "keydown") {
                _this.state.filteredSelection.toggle(_this.state.filteredItems.value.indexOf(item), _this.state.filteredSelection.alwaysMerge);
                _this.onSelect(event, item);
            }
        };
        _this.onFilterTextChanged = function (e, newValue) {
            _this.filterText.value = newValue;
            _this.updateFilteredItems();
        };
        _this.onSelect = function (event, item) {
            var selection = _this.parentSelection;
            if (selection.value.length > 0 && !selection.multiSelect && !selection.selectOnFocus) {
                _this.onDismiss();
            }
            if (_this.props.onSelect) {
                _this.props.onSelect(event, item);
            }
        };
        _this.selectionChanged = function (value, action) {
            _this.state.filteredSelection.selectionChanged(value, action);
            return true;
        };
        _this.renderCallout = function (dropdown, dropdownId, anchorElement, anchorOffset, anchorOrigin, anchorPoint, dropdownOrigin) {
            var _a = _this.props, actions = _a.actions, calloutContentClassName = _a.calloutContentClassName, containerClassName = _a.containerClassName, filterPlaceholderText = _a.filterPlaceholderText, filteredNoResultsText = _a.filteredNoResultsText, getUnselectableRanges = _a.getUnselectableRanges, items = _a.items, loading = _a.loading, noItemsText = _a.noItemsText, renderItem = _a.renderItem, searching = _a.searching, showFilterBox = _a.showFilterBox, userFilteredItems = _a.userFilteredItems, width = _a.width;
            var _b = _this.state, filteredItems = _b.filteredItems, filterText = _b.filterText, filteredSelection = _b.filteredSelection;
            var calloutProps = {
                actions: actions,
                anchorElement: anchorElement,
                anchorOffset: anchorOffset,
                anchorOrigin: anchorOrigin,
                anchorPoint: anchorPoint,
                calloutContentClassName: calloutContentClassName,
                containerClassName: containerClassName,
                dropdownOrigin: dropdownOrigin,
                filteredItems: filteredItems,
                filteredNoResultsText: filteredNoResultsText,
                selection: filteredSelection,
                filterPlaceholderText: filterPlaceholderText,
                filterText: filterText,
                getUnselectableRanges: getUnselectableRanges,
                id: dropdownId,
                items: items,
                loading: loading,
                noItemsText: noItemsText,
                onActivate: _this.onActivate,
                onFilterTextChanged: _this.onFilterTextChanged,
                onDismiss: _this.onDismiss,
                onSelect: _this.onSelect,
                renderItem: renderItem,
                searching: searching,
                showFilterBox: showFilterBox,
                updateFilteredItems: _this.updateFilteredItems,
                userFilteredItems: userFilteredItems,
                width: width
            };
            return _this.props.renderCallout(calloutProps);
        };
        _this.updateFilteredItems = function () {
            updateFilteredItems(_this.props, _this.state);
            return true;
        };
        _this.parentSelection = props.selection || new DropdownSelection();
        var wrappedItems = wrapListBoxItems(props.items);
        var itemsValue = getListBoxItemsValue(wrappedItems || props.items);
        _this.state = {
            filteredItems: new ObservableArray(itemsValue.slice()),
            filteredSelection: new FilteredListSelection(_this.parentSelection),
            filterText: _this.filterText,
            props: props,
            wrappedItems: wrappedItems
        };
        return _this;
    }
    Dropdown.getDerivedStateFromProps = function (props, state) {
        if (props.userFilteredItems !== state.props.userFilteredItems || props.items !== state.props.items) {
            updateFilteredItems(props, state);
        }
        return tslib_1.__assign({}, state, { props: props, wrappedItems: wrapListBoxItems(props.items) });
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, className = _a.className, items = _a.items, placeholder = _a.placeholder, onCollapse = _a.onCollapse, renderExpandable = _a.renderExpandable;
        var selectionObservable = { observableValue: this.parentSelection, filter: this.selectionChanged };
        return (React.createElement(ItemsObserver, { getUnselectableRanges: this.props.getUnselectableRanges, items: items, selection: this.parentSelection },
            React.createElement(Observer, { selection: selectionObservable }, function () {
                return renderExpandable({
                    ariaLabel: ariaLabel,
                    className: className,
                    placeholder: placeholder,
                    onCollapse: onCollapse,
                    onExpand: _this.onExpand,
                    expandableRef: _this.expandable,
                    renderCallout: _this.renderCallout,
                    items: getListBoxItemsValue(_this.state.wrappedItems || items),
                    renderSelectedItems: renderDropdownSelectedItemText,
                    selection: _this.parentSelection
                });
            })));
    };
    Dropdown.prototype.focus = function () {
        if (this.expandable.current) {
            this.expandable.current.focus();
        }
    };
    Dropdown.defaultProps = {
        filterByText: true,
        filterItem: filterItemByText,
        getUnselectableRanges: getUnselectableRanges,
        renderCallout: DropdownCallout,
        renderExpandable: DropdownExpandableTextField,
        renderSelectedItems: renderDropdownSelectedItemText
    };
    return Dropdown;
}(React.Component));
export { Dropdown };
export function filterItemByText(filterText, item) {
    if (item.text && item.type !== 2 /* Header */ && item.type !== 3 /* Divider */) {
        return item.text.toLowerCase().indexOf(filterText.toLowerCase()) !== -1;
    }
    return false;
}
export function renderDropdownSelectedItemText(selection, items) {
    var text = items[selection.value[0].beginIndex].text || "";
    if (selection.selectedCount > 1) {
        text = text + " (+" + (selection.selectedCount - 1) + ")";
    }
    return text;
}
function updateFilteredItems(props, state) {
    var filteredSelection = state.filteredSelection, filterText = state.filterText;
    var filteredIndexMap = [];
    var items = getListBoxItemsValue(state.wrappedItems || props.items);
    var filteredItems = items;
    if (props.userFilteredItems) {
        filteredItems = getItemsValue(props.userFilteredItems);
        for (var filteredIndex = 0; filteredIndex < props.userFilteredItems.length; filteredIndex++) {
            var index = items.indexOf(filteredItems[filteredIndex]);
            if ($DEBUG) {
                if (index === -1) {
                    console.error("filteredItems contains an item not in items. " +
                        "Selection cannot be maintained unless filteredItems is a subset of items. " +
                        "Check item in filteredItems at index " +
                        filteredIndex);
                }
            }
            filteredIndexMap.push(index);
        }
    }
    if (props.filterByText && filterText.value) {
        var filteredTextItems = [];
        var filteredTextIndexMap = [];
        var currentGroup = "";
        if (props.filterItem) {
            for (var i = filteredItems.length - 1; i >= 0; i--) {
                // Add Dividers and Headers if they have an item from their group showing.
                if ((filteredItems[i].type === 2 /* Header */ || filteredItems[i].type === 3 /* Divider */) &&
                    filteredItems[i].groupId &&
                    filteredItems[i].groupId === currentGroup) {
                    var index = filteredIndexMap.length ? filteredIndexMap[i] : i;
                    filteredTextIndexMap.unshift(index);
                    filteredTextItems.unshift(filteredItems[i]);
                }
                if (props.filterItem(filterText.value, filteredItems[i], items)) {
                    var index = filteredIndexMap.length ? filteredIndexMap[i] : i;
                    filteredTextIndexMap.unshift(index);
                    filteredTextItems.unshift(filteredItems[i]);
                    currentGroup = filteredItems[i].groupId;
                }
            }
        }
        filteredItems = filteredTextItems;
        filteredIndexMap = filteredTextIndexMap;
    }
    // Remove the first item if it's a divider
    while (filteredItems.length && filteredItems[0].type === 3 /* Divider */) {
        filteredItems.shift();
        filteredIndexMap.shift();
    }
    if (filterText.value) {
        Utils_Accessibility.announce(filteredItems.length > 0 ? format(Resources.AnnounceFilterResultCount, filteredItems.length) : Resources.NoFilterResults, true);
    }
    state.filteredItems.value = filteredItems;
    filteredSelection.updateFilteredSelection(filteredIndexMap);
    return true;
}
